
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './Components.css';
import { AppContext } from '../contexts/AppContext';
import { Cross2Icon } from '../icons/Icons';
import { useAppStateService } from '../contexts/AppState';

function ShotListContextMenu({ ContextLocation, CurrentShot, HandleShotContext, onClose }) {
  const appState = useAppStateService();
  const ref = useRef(null);
  const handleOptionClicked = option => {
    HandleShotContext(option);
    onClose?.();
  };

  const [safePosition, setSafePosition] = useState({
    x: ContextLocation.x,
    y: ContextLocation.y
  });

  useLayoutEffect(() => {
    const updateSafePosition = () => {
      const menu = ref.current;
      if (!menu) return;

      const padding = 8;

      const menuWidth = menu.offsetWidth;
      const menuHeight = menu.offsetHeight;

      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      const maxX = Math.max(
        padding,
        viewportWidth - menuWidth - padding
      );

      const maxY = Math.max(
        padding,
        viewportHeight - menuHeight - padding
      );

      const x = Math.min(
        Math.max(ContextLocation.x, padding),
        maxX
      );

      const y = Math.min(
        Math.max(ContextLocation.y, padding),
        maxY
      );

      setSafePosition({ x, y });
    };

    updateSafePosition();

    window.addEventListener('resize', updateSafePosition);

    return () => {
      window.removeEventListener('resize', updateSafePosition);
    };
  }, [
    ContextLocation.x,
    ContextLocation.y,
    CurrentShot,
    appState.InApp
  ]);

  useEffect(() => {
    const onPointerDown = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose?.();
      }
    };
    const onKeyDown = e => {
      if (e.key === 'Escape') {
        onClose?.();
      }
    };

    document.addEventListener('pointerdown', onPointerDown, { capture: true });
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('pointerdown', onPointerDown, { capture: true });
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose]);
  return (
    <div
      ref={ref}
      className="desktop-shotlist-context-menu-old"
      style={{
        top: `${safePosition.y}px`,
        left: `${safePosition.x}px`
      }}
    >
      <button
        type="button"
        aria-label="Close menu"
        className="modal-close-button"
        onClick={() => onClose?.()}
      >
        <Cross2Icon width='30px' height='30px' />
      </button>
      <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', gap: '8px' }}>

        <span style={{ height: '60px', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
          Shot #{CurrentShot && CurrentShot.ShotNumber ? CurrentShot.ShotNumber : "NA"}
        </span>
      </div>
      <button className="button" style={{ marginTop: '10px' }} onClick={() => handleOptionClicked('DELETE')}>
        Delete
      </button>
      <button className="button" style={{ marginTop: '10px' }} onClick={() => handleOptionClicked('COPY')}>
        Copy
      </button>
      {appState.InApp && (
        <button className="button" style={{ marginTop: '10px' }} onClick={() => handleOptionClicked('REPLACE')}>
          Replace
        </button>
      )}
      <button className="button" style={{ marginTop: '10px' }} onClick={() => handleOptionClicked('MOVE')}>
        Move
      </button>
    </div>
  );
}

export default ShotListContextMenu;
